<template>
  <div class="backup-container hidebackdrop">
    <b-modal ref="createBackupModal" size="lg custom-overlay" :lazy="true" :hide-footer="true" @shown="setIntialState">
      <div slot="modal-header" class="w-100">
        <p class="float-left modal-title">Create A New Backup</p>
        <b-btn size="sm" class="float-right" variant="flat" @click="closeModal">
          <close-icon class="icon-default close modalclose"></close-icon>
        </b-btn>
      </div>
      <div class="col-md-10 mx-auto h-100">
        <div class="custom-tab">
          <div class="custom-tab-header">
            <div class="step-form">
              <ul>
                <li>
                  <b-btn variant="multistep" v-bind:class="{active:activeTab==='siteSelector',completed:activeTab !='siteSelector'}" @click="gotoTab('siteSelector')">Select Sites</b-btn>
                </li>
                <li>
                  <span class="line"></span>
                </li>
                <li>
                  <b-btn variant="multistep" v-bind:class="{active:activeTab==='details',completed:activeTab =='repository'}" @click="gotoTab('details')" :disabled="$v.sites.$invalid"> Enter Details</b-btn>
                </li>
                <!-- <li>
                  <span class="line"></span>
                </li>
                <li>
                  <b-btn variant="multistep" v-bind:class="{active:activeTab==='repository'}">Select Repository</b-btn>
                </li> -->
              </ul>
            </div>
          </div>
          <div class="custom-tab-body hasfooter">
            <div v-if="activeTab === 'siteSelector'" class="flex-column h-100">
              <div class="custom-tab-body-cont full-height">
                <site-selector :selected.sync="sites" :noheader="true"></site-selector>
              </div>
              <div class="custom-tab-body-footer">
                <div class="text-right">
                  <b-button type="button" variant="primary" @click="activeTab='details'" :disabled="$v.sites.$invalid">Enter Details</b-button>
                </div>
              </div>
            </div>
            <div v-else-if="activeTab ==='details'" class="flex-column h-100">
              <div class="custom-tab-body-cont full-height">
                <b-form class="backup-form">
                  <b-row>
                    <b-col>
                      <b-form-group id="exampleInputGroup1" label="Backup name" label-for="backupname">
                        <b-form-input id="backupname" type="text" v-model="form.backupName" required placeholder="">
                        </b-form-input>
                      </b-form-group>
                      <b-form-group id="exampleInputGroup1" label="No of backups to keep" label-for="noofbackups">
                        <b-btn class="test-minus" variant="flat" @click="decrementLimit">-</b-btn>
                        <b-form-input id="noofbackups" type="text" v-model="form.limit" required placeholder=""></b-form-input>
                        <b-btn variant="flat" @click="incrementLimit">+</b-btn>
                      </b-form-group>
                      <div v-if="$route.params.type==='schedule'">
                        <b-form-group id="exampleInputGroup1" label="When" label-for="when">
                          <b-form-radio-group button-variant="outline-primary" buttons v-model="form.when" :options="whenToBackup" class="active"></b-form-radio-group>
                        </b-form-group>
                      </div>
                      <b-form-group id="options">
                        <b-form-checkbox v-model="form.disableCompression" v-if="form.mechanism !='advancedBackup'">Create zip without compression</b-form-checkbox>
                        <b-form-checkbox v-model="form.optimizeDB" v-if="form.mechanism=='singleCall'">Optimize database tables</b-form-checkbox>
                      </b-form-group>
                      <hr/>

                      <b-form-group id="exampleInputGroup1" label="What" label-for="what" class="mode-group">
                        <b-form-radio-group button-variant="outline-custom" buttons v-model="form.what" :options="whatToBackup" class="active"></b-form-radio-group>
                      </b-form-group>
                      <div v-if="form.what!='db'">
                        <div class="d-flex">
                          <b-form-group label="Exclude files & folders" label-for="excludefiles" class="w-50 px-1">
                            <b-form-input id="excludefiles" type="text" v-model="form.exclude" required placeholder="wp-admin,wp-content,old-backup.zip">
                            </b-form-input>
                          </b-form-group>
                          <b-form-group label="Exclude files of these extensions" label-for="exclude extensions" class="w-50  px-1">
                            <b-form-input id="exclude extensions" type="text" v-model="form.excludeExtensions" required placeholder="e.g. .zip, .mp4">
                            </b-form-input>
                          </b-form-group>
                        </div>

                        <b-form-group id="options">
                          <b-form-checkbox v-model="isExcludeFileSize"></b-form-checkbox>
                          <span class="form-select-label">Exclude files greater than</span>
                          <b-form-select :disabled="!isExcludeFileSize" v-model="excludeFileSize" :options="excludeFileSizeOptions" class="col-md-3" />
                        </b-form-group>
                        <b-form-group label="Include folders" label-for="includefolders">
                          <b-form-input id="includefolders" type="text" v-model="form.include" required placeholder="">
                          </b-form-input>
                        </b-form-group>
                      </div>
                      <b-form-group id="exampleInputGroup1" label="Backup method" label-for="what" class="mode-group">
                        <b-form-radio-group button-variant="outline-custom" buttons v-model="form.mechanism" :options="backupMechanism" class="Cctive"></b-form-radio-group>
                      </b-form-group>
                      <b-form-group id="options" v-if="form.mechanism=='singleCall'">

                        <h6>Enable optimum memory for (use when your backup fails)</h6>
                        <b-form-checkbox v-model="form.failSafeFiles">Files</b-form-checkbox>
                        <b-form-checkbox v-model="form.failSafeDB">DB</b-form-checkbox>

                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
              <div class="custom-tab-body-footer">
                <div class="text-right">
                  <!-- <b-button type="button" variant="primary" @click="activeTab='repository'">Select repository</b-button> -->
                  <b-button type="button" variant="primary" @click="backupNow">Backup Now</b-button>
                </div>
              </div>
            </div>
            <div v-else-if="activeTab ==='repository'" class="flex-column h-100">
              <div class="custom-tab-body-cont full-height">
                <b-form class="backup-form">
                  <b-form-group id="exampleInputGroup1" label="Where to backup?" label-for="where" class="mode-group">
                    <b-form-radio-group button-variant="outline-custom" buttons v-model="form.backupRepoType" :options="backupRepoTypes" class="active"></b-form-radio-group>
                  </b-form-group>
                  <div v-if="form.backupRepoType !='iwp_server'" class="p-2 text-center">
                    <component v-if="isHavingBackupRepository" :is="currentComponent" :config.sync="config[form.backupRepoType]" :type="form.backupRepoType"></component>
                    <span v-else>backup repository promo message will come here</span>
                  </div>
                  <div v-else class="p-2 text-center">
                    Backups will be stored in the server where WP is installed under wp-content/infinitewp/backups
                  </div>

                </b-form>
              </div>
              <div class="custom-tab-body-footer">
                <div class="text-right">
                  <b-button type="button" variant="primary" @click="backupNow">Backup Now</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-modal>
  </div>
</template>

<script>
import CloseIcon from '../../assets/close.svg';
import SiteSelector from '../Common/SiteSelector';
import { required, minLength } from 'vuelidate/lib/validators';
export default {
  name: 'CreateBackup',
  props: ['siteId'],
  components: {
    SiteSelector,
    CloseIcon,
    ftprepo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ FTPRepo }) => FTPRepo
      ),
    amazons3repo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ AmazonS3Repo }) => AmazonS3Repo
      ),
    dropboxrepo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ DropboxRepo }) => DropboxRepo
      ),
    gdriverepo: () =>
      import(/* webpackChunkName: 'backupRepository/index' */ '../addons/BackupRepository/index.js').then(
        ({ GdriveRepo }) => GdriveRepo
      )
  },
  data() {
    return {
      activeTab: 'siteSelector',
      showRepository: false,
      currentComponent: null,
      sites: [],
      isExcludeFileSize: false,
      excludeFileSize: '10',
      form: {
        backupName: '',
        limit: 5,
        include: '',
        disableCompression: true,
        optimizeDB: false,
        fileexclusions: '',
        backupRepoType: 'iwp_server',
        mechanism: 'multiCall',
        what: 'full',
        when: 'daily',
        failSafeDB: false,
        failSafeFiles: false
      },
      whenToBackup: [
        { text: 'Daily', value: 'daily' },
        { text: 'Weekly', value: 'weekly' },
        { text: 'Fortnightly', value: 'fortnightly' },
        { text: 'Monthly', value: 'monthly' }
      ],
      whatToBackup: [
        { text: 'Files & DB', value: 'full' },
        { text: 'DB', value: 'db' },
        { text: 'Files', value: 'files' }
      ],
      backupMechanism: [
        { text: 'Single call', value: 'singleCall' },
        { text: 'Multi call', value: 'multiCall' },
        { text: 'Phoenix (Beta)', value: 'advancedBackup' }
      ],
      backupRepoTypes: [
        { text: 'Wp Server', value: 'iwp_server' },
        { text: 'FTP', value: 'iwp_ftp' },
        { text: 'Amazon S3', value: 'iwp_amazon_s3' },
        { text: 'Dropbox', value: 'iwp_dropbox' },
        { text: 'Google Drive', value: 'iwp_gdrive' }
      ],
      excludeFileSizeOptions: [
        { value: '10', text: '10MB' },
        { value: '50', text: '50MB' },
        { value: '100', text: '100MB' },
        { value: '200', text: '200MB' }
      ],
      config: {}
    };
  },
  validations: {
    sites: {
      required
    }
  },
  computed: {
    backupType() {
      return this.form.backupRepoType;
    },
    isHavingBackupRepository() {
      let installedAddons = this.$store.getters.getInstalledAddons;
      return installedAddons.indexOf('backupRepository') > -1;
    }
  },
  watch: {
    backupType(newType, oldType) {
      switch (newType) {
        case 'iwp_ftp':
          this.currentComponent = 'ftprepo';
          break;
        case 'iwp_amazon_s3':
          this.currentComponent = 'amazons3repo';
          break;
        case 'iwp_dropbox':
          this.currentComponent = 'dropboxrepo';
          break;
        case 'iwp_gdrive':
          this.currentComponent = 'gdriverepo';
          break;
      }
    },
    sites(newValue) {}
  },
  methods: {
    setIntialState() {
      Object.assign(this.$data, this.$options.data.apply(this));
      this.sites = [];
      if (this.siteId) {
        this.sites = [this.siteId];
        this.activeTab = 'details';
      }
    },
    incrementLimit() {
      this.form.limit = this.form.limit + 1;
    },
    decrementLimit() {
      if (this.form.limit > 0) {
        this.form.limit = this.form.limit - 1;
      }
    },
    gotoTab(tab) {
      this.activeTab = tab;
    },
    backupNow() {
      let selectedSiteIds = this.sites;
      let payload = {};
      payload.action = 'backup';
      payload.args = {};
      payload.args.siteIDs = selectedSiteIds;
      payload.args.params = {};
      payload.args.params.action = 'now';
      payload.args.params.config = {};
      if (this.isExcludeFileSize) {
        this.form.excludeFileSize = this.excludeFileSize;
      }
      payload.args.params.config = this.form;
      payload.requiredData = {
        getSitesBackupsV3: 1
      };

      // if (this.backupRepoType != "iwp_server") {
      //   payload.args.params.accountInfo = {};
      //   payload.args.params.accountInfo[this.backupRepoType] = this.config[
      //     this.backupRepoType
      //   ];
      // }
      this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          this.$refs.createBackupModal.hide();
        })
        .catch(err => {});
    },
    closeModal() {
      this.$refs.createBackupModal.hide();
    }
  }
};
</script>

<style scoped lang="scss">
.create-backup-form {
  width: 100%;
  margin: auto;
  padding: 11px;
}
#noofbackups {
  width: 40px;
  display: inline;
}
.backup-container {
  /deep/ .modal-backdrop.show {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/protect/CreateBackup.vue